import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { ApproveRegisterRequestParams } from './request';
import { approveRegisterRequest } from './request';

export const useApproveRegisterRequestMutation = (
  settings?: MutationSettings<
    ApproveRegisterRequestParams,
    typeof approveRegisterRequest
  >
) =>
  useMutation({
    mutationKey: ['approveRegisterRequest'],
    mutationFn: ({ config, params }) =>
      approveRegisterRequest({
        params,
        config
      }),
    ...settings?.options
  });
